import * as React from 'react';
import {
  ListItem,
  ListItemCell,
  ListItemSafeText,
} from '../../../shared/List/ListItem';
import { ListAvatar } from '../../../shared/List/ListAvatar';
import { ITest } from '../../../../data/types';
import { formatDateWithTime } from '../../../../utils/date';
import { testMetaString } from '../../../../utils/testMetaString';

interface IProps {
  test: ITest;
  shape: number[];
  style?: React.CSSProperties;
}
export const SelectedListItem = (props: IProps): React.ReactElement => {
  /**
   * @description create the test type string from the test type and tags
   */
  const typeTypeString = testMetaString(
    props.test.testType.abbr,
    props.test.tags
  );

  return (
    <ListItem style={props.style}>
      <ListItemCell style={{ flex: props.shape[0] }}>
        <ListAvatar
          entity={props.test.athlete}
          secondaryText={typeTypeString}
        />
      </ListItemCell>
      <ListItemCell style={{ flex: props.shape[1] }}>
        <ListItemSafeText>
          {formatDateWithTime(props.test.timestamp)}
        </ListItemSafeText>
      </ListItemCell>
    </ListItem>
  );
};
